import { Outlet } from 'react-router-dom'

import Header from 'modules/Header'
import Footer from 'modules/Footer'
import ScrollToTop from 'components/ScrollToTop'

function Layout() {
	return (		
		<>
			<ScrollToTop />
			<div className="App">
				<Header />
				<Outlet />
				<Footer />
			</div>
		</>
	)
}

export default Layout
